import { NormalizerHelper } from './normalizer.helper';
import { Especificacao } from '../models/especificacao.model';
import { EnumTipoCodigoEspecificacao } from '../enums/enum-tipo-codigo-especificacao.enum';

/**
 * Helper com métodos estáticos para formatação de identificação de especificações.
 * Fonte da verdade para a pipe `especificacaoTitulo`.
 */
export class EspecificacaoHelper {
  static correspondeCodigo(especificacao: Especificacao, busca: string, tipo: EnumTipoCodigoEspecificacao): boolean {
    const texto = busca.trim();
    if (!/^\d+$/.test(texto)) return false;
    const prefixo = texto.replace(/^0+/, '');
    if (!prefixo) return false;
    if (tipo === EnumTipoCodigoEspecificacao.ITEM) {
      return Number.isSafeInteger(especificacao.CODESPECIFICACAO) && especificacao.CODESPECIFICACAO > 0
        && String(especificacao.CODESPECIFICACAO).startsWith(prefixo);
    }
    if (tipo !== EnumTipoCodigoEspecificacao.SIGA) return false;
    const origens = especificacao.ORIGENSSIGA;
    const codigos = Array.isArray(origens) && origens.length ? origens.map(origem => origem.CODITEMSIGA)
      : especificacao.TOTALORIGENSSIGA === undefined || especificacao.TOTALORIGENSSIGA === 1 ? [especificacao.CODITEMSIGA] : [];
    return codigos.some(codigo => /^\d+$/.test(String(codigo ?? '')) && String(codigo).replace(/^0+/, '').startsWith(prefixo));
  }

  /** Compõe "código com 6 dígitos | título" para exibição em listagens. */
  static tituloComCodigo(codigo: number | null | undefined, titulo: string): string {
    if (!codigo) return titulo;
    return `${NormalizerHelper.padStart(codigo, 6)} | ${titulo}`;
  }
}
